export const CartOperations = {
    CLEAR: "clear",
    INCREASE: "increase",
    DECREASE: "decrease",
} as const;

export type CartOperationsTypes = (typeof CartOperations)[keyof typeof CartOperations];
